import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback } from "react";
import { useForm } from "react-hook-form";

import { Button } from "~/components/Button";
import { TextInput } from "~/components/TextInput";

import { schema, type UpdateAdminFormType } from "./schema";

type Props = {
	defaultValues?: UpdateAdminFormType;
	onSubmit(payload: UpdateAdminFormType): Promise<void>;
};

export const UpdateAdminForm: React.FC<Props> = ({
	defaultValues,
	onSubmit,
}) => {
	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm<UpdateAdminFormType>({
		resolver: zodResolver(schema),
		defaultValues,
	});

	const submit = useCallback(
		async (payload: UpdateAdminFormType) => {
			await onSubmit(payload);
		},
		[onSubmit],
	);

	return (
		<form
			className="flex-1 flex flex-col gap-4"
			onSubmit={handleSubmit(submit)}
		>
			<h1 className="text-3xl text-center font-semibold">Atualizar Perfil</h1>
			<TextInput
				placeholder="Seu Nome"
				label="Nome"
				{...register("name")}
				error={errors.name?.message}
			/>
			<TextInput
				placeholder="Seu E-mail"
				label="Email"
				inputMode="email"
				{...register("email")}
				error={errors.email?.message}
			/>
			<TextInput
				placeholder="Sua senha"
				label="Senha (Opcional)"
				type="password"
				{...register("password")}
				error={errors.password?.message}
			/>
			<Button
				title="Atualizar"
				loading={isSubmitting}
				loadingMessage="Atualizando..."
			>
				<span>Atualizar</span>
			</Button>
		</form>
	);
};
